import { render } from "./NewsLine.vue?vue&type=template&id=b8b237a6&scoped=true"
import script from "./NewsLine.vue?vue&type=script&lang=js"
export * from "./NewsLine.vue?vue&type=script&lang=js"

import "./NewsLine.vue?vue&type=style&index=0&id=b8b237a6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b8b237a6"

export default script